/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize PatientsCreation View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './patientsViewEdit';

export const mapStateToPropsPatientViewEdit = mapStateToProps;
export const mapDispatchToPropsPatientViewEdit = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientViewEdit,
  mapDispatchToPropsPatientViewEdit
)(View);
